<template>
  <div class="not-found">
    <h1>Az oldal nem létezik</h1>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "NotFound",
  data() {
    return {};
  }
};
</script>

<style scoped lang="less">
.not-found {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 140px);
  background-image: url("~@/assets/ntk_welcome_bg.jpg");
}
</style>

